/* unplugin-vue-components disabled */import script from "./StatusPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatusPanel.vue?vue&type=script&lang=ts&setup=true"

import "./StatusPanel.vue?vue&type=style&index=0&id=32e8f14e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e8f14e"]])

export default __exports__